import {
  FilterMode,
  AuthorCollectingSociety_OrderBy,
  AuthorCollectingSociety,
  SortOrder,
  AuthorCollectingSociety_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const authorCollectingSocietyService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.authorCollectingSocietyOne({ id });
    return result.authorCollectingSocietyOne as AuthorCollectingSociety;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AuthorCollectingSociety_OrderBy[] | null = null,
    filter: AuthorCollectingSociety_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AuthorCollectingSociety_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          {
            collectingSociety: {
              acronym: { contains: searchValue, mode: FilterMode.Insensitive },
            },
          },
          {
            memberNumber: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.authorCollectingSocietyListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ memberNumber: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.authorCollectingSocietyListWithOffset
    ) as AuthorCollectingSociety[];
    return { list, orderBy };
  },
};
